import { defaultTo } from 'lodash';
import {
  IModel,
  Model,
  ModelRecord,
  OrganizationListingModel,
} from '@common/models';

export interface ISalesPackagePriceRuleOrganizationModel extends IModel {
  salesPackagePriceRuleOrganizationId: number;
  salesPackagePriceRuleId: number;
  organizationId: number;
  organization: OrganizationListingModel;
}

export class SalesPackagePriceRuleOrganizationModel
  extends Model
  implements ModelRecord<ISalesPackagePriceRuleOrganizationModel>
{
  salesPackagePriceRuleOrganizationId: number;
  salesPackagePriceRuleId: number;
  organizationId: number;
  organization: OrganizationListingModel;
  constructor(params?: Partial<ISalesPackagePriceRuleOrganizationModel>) {
    super(params);
    this.salesPackagePriceRuleOrganizationId = defaultTo(
      params?.salesPackagePriceRuleOrganizationId,
      0,
    );
    this.salesPackagePriceRuleId = defaultTo(
      params?.salesPackagePriceRuleId,
      0,
    );
    this.organizationId = defaultTo(params?.organizationId, 0);
    this.organization = params?.organization
      ? new OrganizationListingModel(params.organization)
      : new OrganizationListingModel();
  }
}
